import { FC } from 'react';
import { SegmentFieldBaseProps } from './helpers';
import SegmentFieldBase from './base';
import Text from '@/components/text';
import { Stack } from '@mui/material';
import { createUseStyles } from 'react-jss';

interface Props extends Omit<SegmentFieldBaseProps, 'rightContent'> {
  rightValue: string;
  rightExtraCount?: number;
}

const useStyles = createUseStyles({
  rightValue: {
    minWidth: 0,
    width: '100%',
    gap: 6,
  },
  rightValuePrefix: {
    minWidth: 0,
    maxWidth: 200,
    flex: 1,
  },
  rightValueSuffix: {
    flexShrink: 0,
  },
});

export const SegmentField: FC<Props> = ({ rightValue, rightExtraCount, leftLabel, ...rest }) => {
  const styles = useStyles();
  const suffix = rightExtraCount ? `, +${rightExtraCount} more` : '';
  const hasSuffix = !!suffix;

  return (
    <SegmentFieldBase
      {...rest}
      leftLabel={leftLabel}
      rightContent={
        <Stack direction="row" alignItems="center" px={1} className={styles.rightValue}>
          <Text size="x-small" dotdot className={styles.rightValuePrefix}>
            {rightValue}
          </Text>
          {hasSuffix && (
            <Text size="x-small" className={styles.rightValueSuffix}>
              {suffix}
            </Text>
          )}
        </Stack>
      }
    />
  );
};

export default SegmentField;
